/// <reference path="./HAFile.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class MultiMedia extends HAFile {

        /**
         *
         * @returns {string}
         */
        public getType() {
            return "MultiText";
        }

        /**
         *
         * @returns {Map<any, any>}
         */
        public getChoices() {
            const r = new Map();
            const choices = this.getSelected();

            if (choices) {
                const me = this;
                choices.forEach((c: any) => {
                    if (c instanceof Tag) {
                        r.set(r.size, toMap({item: c, s: me.isSelected(c)}));
                        return;
                    }
                    r.set(c, toMap({v: c, s: me.isSelected(c)}));
                });
            }

            return r;
        }

        protected getChoicesLength() {
            return 0;
        }

        protected isSelected(value: any) {
            return true;
        }

        protected add(item: any) {
            if (typeof item === "string") {
                item = new Div(new Img(toMap({class: "thumb",src : item})));
            }
            super.add(item);
        }
    }
}
